import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import { Settings } from './Settings';
import { SearchBar } from './SearchBar';
import Dialog from './Dialog';
import PolicyWording from './PolicyWording';
import CookieBar from './CookieBar';
import Snapshot from './Snapshot';
import { Message } from './Message';
import { SearchResult } from './SearchResult';
import { FilterBar } from './FilterBar';
import { PreviousSearches } from './PreviousSearches';
import { doSearch } from "../services/ferretService";
import { filterResults } from "../services/filterService";
import { start, startSearch, checkStores, SearchService } from '../services/signalRservice';
import _ from "lodash";
import queryString from 'query-string';


export default class MainPage extends Component {
  

  state = {
    showSettings: false,
    showMessage: false,
    stores: [],
    results: [],
    percentage: null,
    previousSearches: [],
    cookieAcceptance: false,
    showCookiePolicy: false,
    filteredCount: 0,
    displayItem: null
  };


  resultArray = [];

  checkService = new SearchService('CheckStore', 'CheckResult', (store) => {


    if (store.store === "Spartan RC") {
      store.found = true;
    }

    var stores = [...this.state.stores];
    var thisStore = stores.filter(s => s.handlerName === store.store)[0];

    thisStore.isOk = store.found;

    this.setState(function (prevState, props) {
      return { stores }
    });

  });

  
  searchService = new SearchService('SearchStore', 'StoreResult', (store) => {

    

    var s = this.resultArray.filter(s => s.handlerName === store.store)[0];

    s.completed = true;
    s.results = store.results;


    var completed = this.resultArray.filter(s => s.completed).length;
    var percentage = parseInt((completed / this.resultArray.length) * 100);

    if (percentage === 100) {
      setTimeout(() => { this.setState({ percentage: null }) }, 4000);
    }

    if (!store.results) {
      this.setState({ percentage });
      return;
    }

    var results = [..._.flatten(this.resultArray.filter(a => a.results != null).map(a => a.results.map(r => r)))];

    this.setState(function (prevState, props) {
      return { results: results, percentage }
    });

  });


  async componentDidMount() {

    this.checkService.start();
    this.searchService.start();

    await start();

    const cookieAcceptance = this.checkCookieAcceptance();

    let previousStores = null;

    if (cookieAcceptance) {
      this.populatePreviousSearches();
      previousStores = this.getStoresFromStorage();
    }

    this.populateStores(previousStores).then(() => {
      
      if (this.props.location.search) {
        const params = queryString.parse(this.props.location.search);
        if(params.search)this.handleSelect(params.search);
      }

    });

    this.setState({ cookieAcceptance });

    this.storeStatus();


  }

  checkCookieAcceptance() {
    const cookieAcceptance = localStorage.getItem("cookieAcceptance");
    return cookieAcceptance && cookieAcceptance === "true";
  }


  populatePreviousSearches() {
    const previousSearchesData = localStorage.getItem("previousSearches");
    if (previousSearchesData) {
      try {
        this.setState({ previousSearches: JSON.parse(previousSearchesData) });
      } catch (ex) {

      }
    }
  }


  handleSettings = () => {
    const showSettings = this.state.showSettings;
    this.setState({ showSettings: !showSettings });
  }

  handleMessage = () => {
    const showMessage = this.state.showMessage;
    this.setState({ showMessage: !showMessage });

  }


  handleStoreChange = (store, toWhat) => {

    var stores = [...this.state.stores];

    var matchedStore = stores.find(s => s.handlerName === store.handlerName);

    matchedStore.enabled = (toWhat === undefined) ? !store.enabled : toWhat;

    this.setState({ stores });

    if (this.state.cookieAcceptance) localStorage.setItem("providers", JSON.stringify(stores));
  }


  storeStatus = () => {

    this.checkService.run('battery', [...this.state.stores]);
  }


  handleSearch = searchTerm => {

    this.handleFilterChange('best', true, '');

    const storesToSearch = this.state.stores.filter(s => s.enabled);

    if (storesToSearch.length === 0) return;


    this.resultArray = [];

    storesToSearch.map(s => this.resultArray.push({
      handlerName: s.handlerName
    }));


    this.searchService.run(searchTerm, storesToSearch);

    //startSearch(searchTerm, storesToSearch, (store) => {

      //var s = this.resultArray.filter(s => s.handlerName === store.store)[0];

      //s.completed = true;
      //s.results = store.results;


      //var completed = this.resultArray.filter(s => s.completed).length;
      //var percentage = parseInt((completed / this.resultArray.length) * 100);

      //if (percentage === 100) {
      //  setTimeout(() => { this.setState({ percentage: null }) }, 4000);
      //}

      //if (!store.results) {
      //  this.setState({ percentage });
      //  return;
      //}

      //var results = [..._.flatten(this.resultArray.filter(a => a.results != null).map(a => a.results.map(r => r)))];

      //this.setState(function (prevState, props) {
      //  return { results: results, percentage }
      //});


   // });

    setTimeout(() => this.setState({ percentage: 0 }), 1);


    var isSearchStored = this.state.previousSearches.find(t => t === searchTerm);
    if (!isSearchStored) {
      const previousSearches = [...this.state.previousSearches, searchTerm];
      this.setState({ previousSearches });
      if (this.state.cookieAcceptance) localStorage.setItem("previousSearches", JSON.stringify(previousSearches));
    }
  }

  handleClearSettings = () => {
    localStorage.removeItem("previousSearches");
    localStorage.removeItem("providers");
    localStorage.removeItem("cookieAcceptance");
    this.setState({ previousSearches: [], cookieAcceptance: false });
    this.refs.settings.applyAll(true);
  }


  handleSelect = item => {
    this.refs.search.doSearch(item);
  }

  handleRemove = item => {
    var previousSearches = this.state.previousSearches.filter(x => x !== item);
    this.setState({ previousSearches });
    if (this.state.cookieAcceptance) localStorage.setItem("previousSearches", JSON.stringify(previousSearches));
  }

  handleFilterChange = (what, direction, resultFilter) => {
    this.setState({ what, direction, resultFilter });
  }

  handleShowProduct = (item) => {


    this.setState({ displayItem: item });
  }


  render() {
    const { percentage } = this.state;
    const filteredResults = filterResults(this.state.results, this.state.what, this.state.direction, this.state.resultFilter);
    return (
      <div className="content-container">
        <NavMenu onSettingsClicked={this.handleSettings} onMessgaeClicked={this.handleMessage} percentage={this.state.percentage} />

        <SearchBar onSearch={this.handleSearch} ref="search" />
        {this.state.previousSearches && this.state.previousSearches.length > 0 && <PreviousSearches items={this.state.previousSearches} onSelect={this.handleSelect} onRemove={this.handleRemove} />}
        {this.state.results && this.state.results.length > 0 && <FilterBar resultCount={filteredResults.length} onFilterChange={this.handleFilterChange} />}

        <div className="mt-2 results-container">
          {filteredResults && filteredResults.length > 0 && <SearchResult results={filteredResults} onSelect={this.handleSelect} onShowProduct={this.handleShowProduct} />}
          {percentage === 0 && <div className="text-center warming pt-5 pb-5"><i className="fas fa-mug-hot large"></i><div>Warming up the engine. Your results will be here shortly.</div></div>}
         
         
        </div>
        {this.state.showSettings && <Dialog title="Settings" onClose={() => this.setState({ showSettings: false })}> <Settings ref="settings" stores={this.state.stores} onStoreChange={this.handleStoreChange} onClearSettings={this.handleClearSettings}
          cookieAcceptance={this.state.cookieAcceptance} onAcceptanceChange={this.handleAcceptanceChange}></Settings></Dialog>}
        {this.state.showMessage && <Dialog title="Message" onClose={() => this.setState({ showMessage: false })}> <Message ref="message"></Message></Dialog>}
        {!this.state.cookieAcceptance && <CookieBar onAcceptance={() => this.handleAcceptanceChange(true)} onShowPolicy={() => { this.setState({ showCookiePolicy: true }) }} />}
        {this.state.showCookiePolicy && <Dialog title="Cookie Policy" onClose={() => this.setState({ showCookiePolicy: false })}><PolicyWording /> </Dialog>}
        {this.state.displayItem && <Dialog title="" onClose={() => this.setState({ displayItem: null })}><Snapshot item={this.state.displayItem}/> </Dialog>}
        <div className="brand"><a href="https://www.ifblock.com" target="_blank" rel="noopener noreferrer">Darren Brooks | if Block Ltd {new Date().getFullYear()}</a></div>
      </div>

    );
  }


  handleAcceptanceChange = cookieAcceptance => {
    if (cookieAcceptance) {
      localStorage.setItem("cookieAcceptance", true);
      this.setState({ cookieAcceptance });
    } else {
      this.handleClearSettings();
    }

  }

  getStoresFromStorage() {
    let previousStores = null;
    try {
      previousStores = JSON.parse(localStorage.getItem("providers"));
    } catch (ex) {

    }
    if (previousStores) this.setState({ stores: previousStores });
    return previousStores;
  }

  async populateStores(previousStores) {
    const response = await fetch('api/Providers');
    const data = await response.json();

    let newData = null;
    if (previousStores) {
      newData = [...data].map(i => {
        const match = previousStores.find(x => x.handlerName === i.handlerName);
        if (match) {
          return ({ ...i, enabled: match.enabled });
        } else {
          return ({ ...i, enabled: true });
        }

      });
    } else {
      newData = [...data].map(i => ({ ...i, enabled: true }));
    }


    this.setState({ stores: newData, loading: false });

    if (this.state.cookieAcceptance) localStorage.setItem("providers", JSON.stringify(newData));
  }

}
